import { IconBase, IconBaseProps } from "./IconBase";

export const ChevronRightIcon = (props: IconBaseProps) => (
  <IconBase {...props}>
    <path
      fill={props.color ?? "currentColor"}
      stroke="none"
      d="M9.99576 6.50507C9.72239 6.23171 9.27917 6.23171 9.00581 6.50507C8.73244 6.77844 8.73244 7.22166 9.00581 7.49502L13.5108 12L9.00581 16.5051C8.73244 16.7784 8.73244 17.2217 9.00581 17.495C9.27917 17.7684 9.72239 17.7684 9.99576 17.495L14.9958 12.495C15.2691 12.2217 15.2691 11.7784 14.9958 11.5051L9.99576 6.50507Z"
    />
  </IconBase>
);
